export const GLOBAL_HEADER_HEIGHT = 60;
